module.exports = __webpack_public_path__ + "first-20_ir.jpg?e3abe8938bed08ffb910848e27ca4906";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-20_ir.jpg
// module id = 500
// module chunks = 0